<template>
    <WhiteIQOS 
        :title="$t('client_authorization.title')" 
        :subtitle="$t('client_authorization.subtitle')"
        :enabled="smsToggle">

        <div class="qrw-paragraph-md v1-grey-7-color">
            {{ $t('client_authorization.text1') }}
        </div>
        <br>
        <div class="qrw-paragraph-md v1-grey-7-color">
            {{ $t('client_authorization.text2') }}
        </div>

        <template #actions>
            <IQOSToggle v-model="smsToggle"/>
        </template>
    </WhiteIQOS>
</template>

<script>
export default {
    computed: {
        smsToggle: {
            get() {
                return this.$store.state.cafe.client_app.verify_client_phone;
            },
            set(v) {
                this.$store.commit('setClientAppData', {
                    key: 'verify_client_phone',
                    value: v
                });
                this.$store.dispatch('saveCafe');
            }
        }
    }
}
</script>

<style scoped>

</style>